// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CZO0s","top":"styles_top__3uetU"};